module.exports = __webpack_public_path__ + "img/kk-bottom.79dc8e21.png";